import { observable } from "mobx";
import { RacingResultLine } from ".././RacingResultLine";

/**
* RacingResultInfo defines model for branch object information
*
* @typedef RacingResultInfo
* @type {Object}
* @property {id} Id identifier
* @property {eventName} EventName of current racing result info ( translated )
* @property {eventDate} EventDate of current racing result info
* @property {eachWayTerms} EachWayTerms of current racing result info
* @property {leagueId} LeagueId of current racing result info
* @property {masterLeagueName} MasterLeagueName of current racing result info
* @property {masterLeagueId} MasterLeagueId of current racing result info
* @property {foreCastDividents} ForeCastDividents of current racing result info
* @property {triCastDividents} TriCastDividents of current racing result info
* @property {foreCast} ForeCast of current racing result info
* @property {triCast} TriCast of current racing result info
* @property {branchId} BranchId of current racing result info
* @property {countryId} CountryId of current racing result info
* @property {lines} Lines of current racing result info
* @property {withdrawnLines} WithdrawnLines of current racing result info
*/

export class RacingResultInfo {
    id: string;
    eventName: string;
    eventDate: Date;
    eachWayTerms?: string;
    leagueId: string;
    masterLeagueName: string;
    masterLeagueId: string;
    @observable foreCastDividents?: number;
    @observable triCastDividents?: number;
    foreCast?: string;
    triCast?: string;
    branchId: string;
    countryId: string;
    @observable lines?: RacingResultLine[];
    @observable withdrawnLines?: RacingResultLine[];

    constructor(resultData: RacingResultInfo) {
        this.id = resultData.id;
        this.eventName = resultData.eventName;
        this.eventDate = resultData.eventDate;
        this.eachWayTerms = resultData.eachWayTerms;
        this.leagueId = resultData.leagueId;
        this.masterLeagueName = resultData.masterLeagueName;
        this.masterLeagueId = resultData.masterLeagueId;
        this.foreCastDividents = resultData.foreCastDividents;
        this.triCastDividents = resultData.triCastDividents;
        this.foreCast = resultData.foreCast;
        this.triCast = resultData.triCast;
        this.countryId = resultData.countryId;
        this.branchId = resultData.branchId;
        this.lines = resultData.lines;
        this.withdrawnLines = resultData.withdrawnLines;
    }
}
